import script from "./VideoCallInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCallInterface.vue?vue&type=script&setup=true&lang=js"

import "./VideoCallInterface.vue?vue&type=style&index=0&id=0d56377a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d56377a"]])

export default __exports__